<template>
  <div class="mateImagePage">
    <h2 class="patientInfo">
      <span>{{checkOrderInfo.real_name}}</span>
      <span>{{checkOrderInfo.gender === 1 ? '男': '女'}}</span>
      <span>{{checkOrderInfo.service_appointment_actual_datetime}}</span>
      {{checkOrderInfo.checkItem}}
    </h2>
    <div class="mateImageList">
      <Form layout="inline">
        <FormItem class="patientNameInput">
          <Input placeholder="请输入患者姓名" v-model="searchName" />
        </FormItem>
        <FormItem>
          <Input placeholder="请输入检查部位" v-model="searchBody"/>
        </FormItem>
        <FormItem>
          <Select v-model="searchSex" style="width: 120px" placeholder="全部性别" allowClear>
            <SelectOption value="1">男</SelectOption>
            <SelectOption value="2">女</SelectOption>
          </Select>
        </FormItem>
        <!-- <FormItem>
          <Select v-model="searchDevice" style="width: 120px" allowClear :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" placeholder="全部检查设备">
            <SelectOption v-for="item in deviceList" :key="item.id">{{item.name}}</SelectOption>
          </Select>
        </FormItem> -->
        <FormItem>
          <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="searchDate"/>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSearch">搜索</Button>
        </FormItem>
      </Form>
      <div class="tableContent">
        <Table :columns="columns" :dataSource="tableData" rowKey="id" :pagination="false" :customRow="customRow" :rowClassName="rowClassName">
          <div slot="film_no" slot-scope="text, record">
            <span :class="{highLight: record.highlight}">{{record.film_no}}</span>
          </div>
          <span slot="patientInfo" slot-scope="record" :class="{highLight: record.highlight}">{{record.patient_name}}({{record.sex === 1 ? '男' : '女'}})</span>
          <span slot="deviceName" slot-scope="record" :class="{highLight: record.highlight}">{{record.deviceName}}</span>
          <span slot="body" slot-scope="record" :class="{highLight: record.highlight}">{{record.body}}</span>
          <div slot="sequence" slot-scope="text, record">
            <a class="newLink" :class="{highLight: record.highlight}" @click="showImageSequence(record)">{{record.total_sequence_size}}</a>
          </div>
          <span slot="imgNum" slot-scope="record" :class="{highLight: record.highlight}">{{record.total_image_size}}</span>
          <span slot="time" slot-scope="record" :class="{highLight: record.highlight}">{{record.created_date}}</span>
          <span slot="status" slot-scope="record" :class="{highLight: record.highlight}">{{record.status === 1? '已匹配' : '未匹配'}}</span>
        </Table>
      </div>
    </div>
    <div class="buttonWrap">
      <div class="endButton">
        <Button type="primary" @click="clearImage" :disabled="removeFlag" size="large" class="untying">解绑</Button>
        <Button @click="handleBack" size="large">返回</Button>
        <Button type="primary" :disabled="!removeFlag" @click="handleImage" size="large">匹配</Button>
      </div>
    </div>
    <Modal title="提示" v-model="showModal" @ok="handleModalButton" :confirmLoading="handleModalLoading">
      <p v-if="modalType === 1">是否确认将当前影像匹配至患者{{checkOrderInfo.real_name}}</p>
      <div v-if="modalType === 2 || modalType === 3">
        <div style="display:flex;justify-content: space-between;margin-bottom:10px}">
          <b>患者：{{reportInfo.patient_name}}</b><b>报告状态：{{reportStatus(reportInfo.status)}}</b><b>编写医生：{{reportInfo.report_write_doctor_name}}</b><b>审核医生：{{reportInfo.report_review_doctor_name}}</b>
        </div>
        <p v-if="modalType === 3">是否确认更改匹配影像</p>
        <p v-if="modalType === 2">是否确认解绑匹配影像</p>
        <Row><span style="color: red">*</span>请选择原因</Row>
        <RadioGroup v-model="cancel.whyKey">
          <Radio :style="cancel.radioStyle" value="影像不清晰">影像不清晰</Radio>
          <Radio :style="cancel.radioStyle" value="匹配错影像">匹配错影像</Radio>
          <Radio :style="cancel.radioStyle" value="其他">其他</Radio>
        </RadioGroup>
        <div style="margin-left:24px;">
          <TextArea placeholder="请填写其他原因" v-model="cancel.whyMsg" :autosize="{ minRows: 2, maxRows: 10 }" :maxLength="100"/>
        </div>
        <p v-if="modalType === 3" style="color: red">温馨提示：如匹配新的影像包（不同影像号），前一个影像包将自动解绑哦~</p>
        <p v-if="modalType === 2" style="color: red">温馨提示：解绑后医生将无法查看患者的影像且无法完成报告</p>
      </div>
      <!-- <p v-if="modalType === 2">是否解绑当前影像（影像号：{{patientInfo.film_no}}）？</p>
      <p v-if="modalType === 3">是否确认要解绑当前影像并匹配新影像至患者{{checkOrderInfo.real_name}}</p> -->
      <!-- <p v-if="modalType === 4">{{writeDoctorName}}正在编写报告，是否解绑？</p> -->
    </Modal>
    <Modal title="提示" v-model="checkFinishedModal">
      <p v-if="modalType === 4" style="color: red">患者报告已完成，不支持再次匹配影像；</p>
      <p v-if="modalType === 4">如需匹配，请及时联系医生召回报告；</p>
      <p v-if="modalType === 5" style="color: red">患者报告已完成，不支持再次解绑影像；</p>
      <p v-if="modalType === 5">如需解绑，请及时联系医生召回报告；</p>
      <p>编写医生：{{reportInfo.report_write_doctor_name}}</p>
      <p>审核医生：{{reportInfo.report_review_doctor_name}}</p>
      <div slot="footer">
        <Button size="large" @click="backFinished">返回</Button>
      </div>
    </Modal>
    <Modal v-model="sequenceDetailFlag" title="影像序列明细" :footer="null" :forceRender="false" :width='700'>
      <sequenceDetails v-if="sequenceDetailFlag" @closeSequenceDetails=closeSequenceDetails :sequenceDetails="sequenceDetails"></sequenceDetails>
    </Modal>
  </div>
</template>

<script>
import { Button, Form, Input, Select, DatePicker, Table, Modal, Row, Radio } from 'ant-design-vue'
import moment from 'moment'
import { switchTimeFormat, toast } from '../../libs/utils'
import { getMateImageList, mateImage, removeImage, getReportInfo } from '../../api/mateImage'
import { getCheckOrderDetails } from '../../api/check'
import { mapState } from 'vuex'
import { reportStatus } from '../../core/filter'
import sequenceDetails from '../../components/sequenceDetails'
export default {
  props: {
    checkOrderId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Button,
    Form,
    FormItem: Form.Item,
    Input,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Table,
    Modal,
    Row,
    RadioGroup: Radio.Group,
    Radio,
    TextArea: Input.TextArea,
    sequenceDetails
  },
  data () {
    return {
      columns: [
        { title: '影像号', scopedSlots: { customRender: 'film_no' }},
        { title: '姓名/性别', scopedSlots: { customRender: 'patientInfo' }},
        { title: '设备类型', scopedSlots: { customRender: 'deviceName' }},
        { title: '检查部位', scopedSlots: { customRender: 'body' }},
        { title: '序列数量', scopedSlots: { customRender: 'sequence' }},
        { title: '图片数量', scopedSlots: { customRender: 'imgNum' }},
        { title: '接收影像时间', scopedSlots: { customRender: 'time' }},
        // { title: '检查备注', scopedSlots: { customRender: 'remarks' }},
        // { title: '检查时间', scopedSlots: { customRender: 'time' }},
        { title: '匹配状态', scopedSlots: { customRender: 'status' }}
      ],
      tableData: [],
      searchName: '',
      searchBody: '',
      searchSex: undefined,
      searchDevice: undefined,
      searchDate: moment(switchTimeFormat(new Date().valueOf(), 1)),
      showModal: false,
      modalType: 1,
      imageId: '',
      removeFlag: true,
      patientInfo: {},
      checkOrderInfo: {},
      writeDoctorName: '',
      handleModalLoading: false,
      cancel: {
        whyKey: null,
        whyMsg: '',
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        }
      },
      checkFinishedModal: false,
      reportInfo: {},
      sequenceDetails: '',
      sequenceDetailFlag: false
    }
  },
  computed: {
    ...mapState({
      deviceList: state => state.app.devices,
    })
  },
  async mounted () {
    let data = await getCheckOrderDetails( {id: this.checkOrderId })
    if (data) {
      let arr = []
      for (let i = 0; i < data.checkItemList.length; i++) {
        arr.push(data.checkItemList[i].name)
      }
      data.checkItem = arr.toString()
      this.checkOrderInfo = data
      // this.searchName = this.checkOrderInfo.real_name
      this.handleSearch()
    }
  },
  methods: {
    customRow (record) {
      return {
        on: {
          click: () => {
            this.imageId = record.id
            this.patientInfo = record
            if (record.highlight) {
              this.removeFlag = false
            } else {
              this.removeFlag = true
            } 
          }
        }
      }
    },
    rowClassName (record) {
      return record.id === this.imageId ? 'clickRowStyl' : '';
    },
    async handleSearch () {
      let params = {
        orderCheckId: this.checkOrderId
      }
      if (this.searchName) params.patientName = this.searchName
      if (this.searchBody) params.bodyName = this.searchBody
      if (this.searchSex) params.gender = this.searchSex
      if (this.searchDate) params.checkTime = this.searchDate.format('YYYY-MM-DD')
      let data = await getMateImageList(params)
      this.imageId = ''
      if (data) this.tableData = data
    },
    // 匹配
    async handleImage () {
      if (!this.imageId) return Modal.warning({ title: '提示', content: '请选择需要匹配的影像' })
      let data = await getReportInfo({ orderCheckId: this.checkOrderId })
      if (data) this.reportInfo = data
      if (data && data.status === 100) {
        this.checkFinishedModal = true
        this.modalType = 4
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].highlight === true) {
            this.modalType = 3
          } else {
            this.modalType = 1
          }
        }
        this.showModal = true
      }
    },
    // 解绑
    async clearImage () {
      let data = await getReportInfo({ orderCheckId: this.checkOrderId })
      if (data) this.reportInfo = data
      if (data && data.status === 100) {
        this.checkFinishedModal = true
        this.modalType = 5
      } else {
        this.showModal = true
        this.modalType = 2
      }
    },
    async handleModalButton () {
      let params = {
        orderImageId: this.imageId,
        orderCheckId: this.checkOrderId
      }
      if (this.modalType === 3 || this.modalType === 2) {
        if (!this.cancel.whyKey) return toast({ title: '提示', type: 'warning', msg: '请选择原因！' })
        if (this.cancel.whyKey && this.cancel.whyKey !== '其他') params.changeReason = this.cancel.whyKey
        if (this.cancel.whyKey && this.cancel.whyKey === '其他') {
          if (!this.cancel.whyMsg.trim()) {
            return toast({ title: '提示', type: 'warning', msg: '请填写其他原因' })
          } else {
            params.changeReason = this.cancel.whyMsg
          }
        }
      }
      if (this.handleModalLoading) return false
      this.handleModalLoading = true
      if (this.modalType === 1 || this.modalType === 3) {
        let data = await mateImage(params)
        if (data) {
          Modal.success({ title: '提示', content: '影像已匹配' })
          this.showModal = false
          this.imageId = ''
          this.patientInfo = {}
          this.handleModalLoading = false
          this.handleSearch()
        }
      } else {
        let data = await removeImage(params)
        if (data) {
          this.showModal = false
          this.imageId = ''
          this.patientInfo = {}
          this.handleModalLoading = false
          this.handleSearch()
        }
      }
    },
    reportStatus (num) {
      return reportStatus(num)
    },
    handleBack () {
      this.$emit('closeModal')
    },
    backFinished () {
      this.checkFinishedModal = false
    },
    // 查看序列明细
    showImageSequence (record) {
      this.sequenceDetails = record.image_list_detail
      this.sequenceDetailFlag = true
    },
    closeSequenceDetails () {
      this.sequenceDetailFlag = false
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.mateImagePage{
  .patientInfo{
    margin-bottom:20px;
    background:#f2f2f2;
    font-size: @bigFontSize;
    span{
      margin-right: 10px;
    }
  }
  .mateImageList{
    padding-bottom:20px;
    .patientNameInput{
      width: 8em;
    }
    .tableContent{
      max-height: 500px;
      overflow-y: auto;
      .newLink{
        text-decoration: underline;
        padding: 20px;
      }
    }
    .highLight{
      color: red;
    }
    .clickRowStyl{
      background: @primaryColor;
      color:#fff;
      .newLink{
        color: #fff;
        text-decoration: underline;
        padding: 20px;
      }
    }
    .ant-table-tbody>.clickRowStyl:hover>td {
      background: @primaryColor;
    }
  }
  .buttonWrap{
    .modalFooter();
    .untying{
      float: left;
      margin-left: 8px;
    }
    .ant-btn-lg{
      width: 100px;
      height: 56px;
    }
  }
  .imagesWrapper{
    .patientImagesDetails{
      // display: flex;
      // justify-content: space-between;
      color: red;
    }
  }
  
}
</style>